import CheckBareIcon from "../../shared/Icons/CheckBareIcon";
import { themeAtom } from "../../shared/atoms";
import { DropdownVessel } from "../models/certificates.interfaces";
import { checkIsSameVessel } from "../services/certificates.service";
import { useAtomValue } from "jotai";
import { Virtuoso } from "react-virtuoso";
import { twMerge } from "tailwind-merge";

interface VesselSelectionTableProps {
  vessels: DropdownVessel[];
  onSelectVessel: (vessel: DropdownVessel) => void;
  isOpen: boolean;
  selectedVessel?: DropdownVessel | undefined;
}

const VesselTableHeader = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "sticky top-0 flex border-b py-3 pl-4 pr-[16px] font-bold",
        theme.certVesselSelect.tableBorder,
        theme.home.tailwind.backgound,
      )}
    >
      <div className="flex-[9]">Vessel</div>
      <div className="flex-[4]">Code</div>
      <div className="flex-[5]">IMO</div>
      <div className="flex-[7]">Type</div>
      <div className="flex-[1]" />
    </div>
  );
};

const VesselTableItem = ({
  vessel,
  selectedVessel,
}: {
  vessel: DropdownVessel;
  selectedVessel: DropdownVessel | undefined;
}) => {
  const { vesselName, code, imoNumber, type } = vessel;
  return (
    <div className="flex items-center">
      <div className="flex-[9]">{vesselName}</div>
      <div className="flex-[4]">{code}</div>
      <div className="flex-[5]">{imoNumber}</div>
      <div className="flex-[7]">{type}</div>
      <div className="flex flex-[1] items-center">
        {checkIsSameVessel(vessel, selectedVessel) && <CheckBareIcon className="w-[25px]" color={"#1F8475"} />}
      </div>
    </div>
  );
};

export const VesselTable: React.FC<VesselSelectionTableProps> = ({
  vessels,
  onSelectVessel,
  isOpen,
  selectedVessel,
}) => {
  const theme = useAtomValue(themeAtom);

  const handleVesselSelect = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, vessel: DropdownVessel) => {
    event.stopPropagation();
    onSelectVessel(vessel);
  };

  return isOpen ? (
    <div className="absolute min-w-[550px]">
      <div
        className={twMerge(
          "absolute z-20 mt-1 w-full rounded-[4px] border text-[12px] shadow-[0_8px_16px_#45505229]",

          theme.home.tailwind.backgound,
          theme.certVesselSelect.tableText,
          theme.certVesselSelect.tableBorder,
        )}
      >
        <VesselTableHeader />

        {vessels.length ? (
          <Virtuoso
            data={vessels}
            style={{ height: `${vessels.length * 64}px`, maxHeight: "240px" }}
            className={twMerge(
              "overflow-y-auto",
              "[&::-webkit-scrollbar]:w-1.5",
              "[&::-webkit-scrollbar-track]:bg-transparent",
              "[&::-webkit-scrollbar-thumb]:rounded-full",
              theme.uwhcAssistant.tableScroll,
              theme.uwhcAssistant.scrolHover,
            )}
            itemContent={(index: number, option: DropdownVessel) => (
              <div
                className={twMerge(
                  "cursor-pointer items-center rounded-[4px] px-4 py-[12px]",
                  theme.certVesselSelect.hoverSelect,
                )}
                key={`${option}-${index}`}
                onClick={(e) => handleVesselSelect(e, option)}
              >
                <VesselTableItem vessel={option} selectedVessel={selectedVessel} />
              </div>
            )}
          />
        ) : (
          <div className="flex justify-center p-12">No Vessels Found</div>
        )}
      </div>
    </div>
  ) : null;
};
